// extracted by mini-css-extract-plugin
module.exports = {"form":"SearchForm_form__60rfh","input":"SearchForm_input__3bnM1","icon":"SearchForm_icon___T_yM"};